var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hiq-event-view",class:_vm.isVisitSite ? 'hiq-event-view__visit' : ''},[(_vm.type !== 'page')?_c('heading'):_vm._e(),(_vm.type !== 'page')?_c('text-and-image'):_vm._e(),_c('share-event'),_c('info')],1)}
var staticRenderFns = []

export { render, staticRenderFns }